import {
  FETCH_RESTRICTED_PRODUCT_LIST,
  RESET_RESTRICTED_PRODUCT_LIST,
} from "../../constants/action.constants";

const initialState = {
  list: [],
  others: {},
};

const restrictedProductListReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_RESTRICTED_PRODUCT_LIST:
      return { list: action.payload, others: action.others };
    case RESET_RESTRICTED_PRODUCT_LIST:
      return initialState;
    default:
      return state;
  }
};

export default restrictedProductListReducer;
